// @ts-nocheck
import * as _ from 'lodash';
import { isEmpty } from '../helpers';
import {
  SlickGrid,
  SlickPlugin,
  SlickEvent,
  OnHeaderRowCellRenderedEventArgs,
  SlickEventHandler,
  SlickEventData,
  Utils,
} from 'slickgrid';

export interface OnColumnFilterChangeEventArgs {
  filters: Dictionary<string>;
  previousFilters: Dictionary<string>;
}

export class HeaderRowFilters<T = any> implements SlickPlugin {
  // --
  // public API
  pluginName = 'HeaderRowFilters' as const;

  // --
  // protected props
  protected _grid!: SlickGrid;
  protected _handler = new SlickEventHandler();
  protected filters: Dictionary<string> = {};

  private unsubscribeAll: () => void;

  readonly onColumnFilterChange = new SlickEvent<T>();

  getOptions() {
    return {
      showHeaderRow: true,
      headerRowHeight: 28,
    };
  }

  init(grid: SlickGrid): void {
    this._grid = grid;
    this._handler.subscribe(
      this._grid.onHeaderRowCellRendered,
      this.onHeaderRowCellRendered.bind(this),
    );

    const handleInputChange = _.throttle(_.partial(onInputChange, this), 300);
    const handleSearch = _.throttle(_.partial(onSearch, this), 300);

    const hr = grid.getHeaderRow();
    for (const el of Array.isArray(hr) ? hr : [hr]) {
      el.addEventListener('change', handleInputChange);
      el.addEventListener('keyup', handleInputChange);
      el.addEventListener('search', handleSearch);
    }
    this.unsubscribeAll = () => {
      const hr = grid.getHeaderRow();
      for (const el of Array.isArray(hr) ? hr : [hr]) {
        el.removeEventListener('change', handleInputChange);
        el.removeEventListener('keyup', handleInputChange);
        el.removeEventListener('search', handleSearch);
      }
    };
  }

  destroy(): void {
    this._handler.unsubscribeAll();
    this.unsubscribeAll();
  }

  protected onChange(
    columnId: string,
    newValue: any,
    notify: boolean,
    element: HTMLElement,
  ) {
    newValue = newValue.trim();

    const previousFilters = _.clone(this.filters);

    this.filters[columnId] = newValue;

    if (isEmpty(newValue)) {
      element.classList.remove('has-value');
    } else {
      element.classList.add('has-value');
    }

    if (notify) {
      const filters = _.clone(this.filters);
      this.onColumnFilterChange.notify({ filters, previousFilters });
    }
  }

  protected onHeaderRowCellRendered<T>(
    e: SlickEventData<OnHeaderRowCellRenderedEventArgs>,
  ) {
    const args = e.getArguments();

    if (!args || !args.column.filterable) {
      return;
    }

    const columnId = args.column.id;
    const inputValue = this.filters[columnId];
    const className = ['column-filter'];

    if (!isEmpty(inputValue)) {
      className.push('has-value');
    }

    Utils.emptyElement(args.node);
    const el = Utils.createDomElement('input', {
      type: 'search',
      className: className.join(' '),
    });
    el.dataset['columnId'] = columnId;
    if (!isEmpty(inputValue)) {
      el.value = inputValue;
    }

    args.node.appendChild(el);
  }
}

function onInputChange<T>(self: HeaderRowFilters<T>, e: Event) {
  if (e.target instanceof HTMLInputElement) {
    const newValue = _.trim(e.target.value);
    const columnId = e.target.dataset['columnId'];
    if (columnId) {
      // notify on enter
      // self.onChange(columnId, newValue, e.keyCode === 13, this);
      self.onChange(columnId, newValue, true, e.target);
    }
  }
}

function onSearch<T>(self: HeaderRowFilters<T>, e: Event) {
  if (e.target instanceof HTMLInputElement) {
    const newValue = _.trim(e.target.value);
    const columnId = e.target.dataset['columnId'];
    if (columnId && newValue === '') {
      self.onChange(columnId, newValue, true, e.target);
    }
  }
}
